import { useLocation } from 'react-router';

export default (params, format = (e) => e) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return params.map((p) => format(query.get(p)));
};

export const useQueryMultiple = (params) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return params.reduce((acc, param) => {
    acc[param] = query.getAll(param);
    return acc;
  }, {});
};
